module.exports = __webpack_public_path__ + "static/media/work-teaser2.2ffd93f9.jpg";